import { handleActions } from 'redux-actions';
import { LOGIN, LOGOUT } from '../actions';

const stateDefault = true;

export default  handleActions(
    {
        [LOGIN]: (state, action) => {
            return Object.assign({}, state, action.payload);
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
);